import { dataPhone } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPhone = /*#__PURE__*/createIcon(dataPhone)
export default IconPhone
